import * as Yup from 'yup';

export const reservationSchema = Yup.object({
  name: Yup.string().required('Nombre de quien reserva requierido'),
  email: Yup.string().email().optional(),
  document: Yup.number().required('Ingrese el numero de documento'),
  phone: Yup.number().min(10).required('Ingrese numero celular'),
  date: Yup.string().required('Ingrese la fecha de la reserva'),
  time: Yup.string().required('ingrese la hora de la reserva'),
  attendees: Yup.number().required('Ingrese el numero de asistentes'),
  message: Yup.string().optional(),
  plan: Yup.object()
    .shape({
      label: Yup.string().optional(),
      value: Yup.string().optional(),
    })
    .required('Seleccione un plan')
    .nullable(),
});
